export default "__VITE_ASSET__6456104d__"